module.exports = __webpack_public_path__ + "static/media/KidsFamily_movies.cfeefa3d.png";